import { Injectable } from '@angular/core';
import { WrapperHttpService } from '../../../../../services/wrapper-http-service';
import { Observable } from 'rxjs';
import { HubOverview } from '../../models';
import { HubEndpoint } from '../../constants/hub-endpoint';
import { API_URL } from '../../../../../../services/config';

@Injectable({
  providedIn: 'root',
})
export class HubOverviewService {
  constructor(private http: WrapperHttpService) {}

  getOverviewData(hubId: number): Observable<HubOverview> {
    return this.http.withLoading().get<HubOverview>(`${API_URL}${HubEndpoint.Base}/${hubId}${HubEndpoint.Overview}`);
  }

  updateHubOverview(body: HubOverview): Observable<HubOverview> {
    return this.http.withLoading().post<HubOverview>(`${API_URL}${HubEndpoint.Base}`, body);
  }
}
